import _ from 'lodash';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

export const isStrategyDomainUser = () => {
  const { applicationDomain } = window;
  if (ApplicationDomainUtility.isQubit) return false;
  return !(_.isNull(_.get(applicationDomain, 'id', null)));
};
